import React from 'react';
import { ParallaxBackground } from '../ParallaxBackground';
export function Hero() {
  return <section id="home" className="relative min-h-[100svh] flex items-center pt-20 pb-16" data-id="element-118">
      <ParallaxBackground imageUrl="https://cdn.magicpatterns.com/uploads/uqhH149ycFxQvX1dhApBNM/don-stouder-cOC5IY9jwIQ-unsplash.jpg" overlayOpacity={0.75} data-id="element-119" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-120">
        <div className="max-w-3xl" data-id="element-121">
          <div className="inline-block mb-4 md:mb-6" data-id="element-122">
            <span className="text-apex-green font-bold text-sm md:text-base uppercase tracking-[0.2em]" data-id="element-123">
              Built For Realtors
            </span>
          </div>

          <h1 className="text-white font-extrabold text-[32px] leading-[1.1] md:text-[56px] tracking-tight mb-6" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.55)'
        }} data-id="element-124">
            Get Your Listings Photo-Ready In 48 Hours.
          </h1>

          <p className="text-white/90 text-base md:text-xl leading-relaxed mb-8 md:mb-10 max-w-2xl font-medium" style={{
          textShadow: '0 1px 12px rgba(0,0,0,0.55)'
        }} data-id="element-125">
            Apex Curbside Appeal handles the full exterior cleanup so your
            listings show up sharp, polished, and ready to sell. Phoenix metro
            coverage. Realtor-only service.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-126">
            <a href="#contact" className="bg-apex-green hover:bg-green-600 text-white text-center px-8 py-4 md:py-4 rounded-md font-bold text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 min-h-[48px] flex items-center justify-center" data-id="element-127">
              Request A Quote
            </a>
            <a href="#services" className="bg-transparent border-2 border-white hover:bg-white/10 text-white text-center px-8 py-4 md:py-4 rounded-md font-bold text-lg transition-all min-h-[48px] flex items-center justify-center" data-id="element-128">
              See What We Do
            </a>
          </div>
        </div>
      </div>
    </section>;
}